import  ApiDataService  from './ApiDataService'

const allMessages = (roomId) => {
    let values={roomId:roomId}
    return  ApiDataService.getWithParam("chatmessage/room",values);
  };

  

export default {allMessages}